export default "__VITE_ASSET__CJd4Q4KB__"